exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".dialog-tBk5u{border-radius:8px;background-color:#fff;color:#001a5d}", ""]);

// exports
exports.locals = {
	"dialog": "dialog-tBk5u"
};